import { useLayoutEffect } from 'react'
import { pulseRevealClass } from './revealClass'

/**
 * Cross-dissolves the app content when the branding cinematic lands: tags
 * <html> with .branding-reveal (see globals.scss) so the body fades in while
 * the loading overlay fades out, instead of the branded page popping in
 * fully formed.
 *
 * Pass `eligibleBrandingTag && isApplied` — the class must never be added on
 * non-branded sessions. Layout effect so the fade starts in the same frame
 * the overlay begins hiding: the branded content itself painted earlier,
 * behind the solid overlay, so starting from opacity 0 here is invisible.
 */
export function useBrandingReveal(isRevealed: boolean) {
  useLayoutEffect(() => {
    if (!isRevealed) return
    return pulseRevealClass()
  }, [isRevealed])
}
